import { render, staticRenderFns } from "./ComponentSummary.vue?vue&type=template&id=4bd77b3a&scoped=true&"
import script from "./ComponentSummary.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ComponentSummary.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ComponentSummary.vue?vue&type=style&index=0&id=4bd77b3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd77b3a",
  null
  
)

export default component.exports